import { Component, Input, OnChanges, OnDestroy, OnInit, Renderer2, SimpleChanges, ElementRef, ViewChild } from '@angular/core';
import { Router, Event, NavigationEnd, ActivatedRoute, ParamMap, NavigationStart } from '@angular/router';
import { NbIconLibraries, NbMenuBag, NbMenuService, NbSidebarService, NbWindowService } from '@nebular/theme';
import { OfbizForm, OfbizList } from '@urbannex/ofbiz-forms';
import { Observable, Subject, combineLatest, forkJoin } from 'rxjs';
import { shareReplay } from 'rxjs/internal/operators/shareReplay';
import { takeUntil, delay, withLatestFrom, debounceTime, map, take, tap } from 'rxjs/operators';
import { ActionState, ComponentConfig, BreadCrumbData, SelectedValue, Relation, OutGoingLink, LoadingState, ComponentState, ComponentTask, MenuAndTitleOptions, AssistantConfig } from './shared/model';
import { UbsComponentStoreService } from './ubs-component-store.service';
import { UpdateComponentStoreService } from './update-component-store.service';
import { WindowContainerComponent } from './window-container/window-container.component';
import { CUSTOM_ICONS } from './custom-font-pack';
import { ViewContainersService } from './shared/services/view-containers.service';


@Component({
  selector: 'ubs-view-containers',
  templateUrl: './view-container.component.html',
  styles: [`
    .component-layout-column {
      height:100%;
      display:flex;
      flex-direction:column;
    }
    .row{
      flex:1;
    }
    nb-card{
      height:100%;
    }
    nb-card.component-card.collapsed{
      width:0px;
    }
    `

  ],
  providers: [UbsComponentStoreService]
})
/**
 * Class controls the current view which could be a List, Add, Edit, Display (View), Find
 * Receives inputs for componentConfig and breadCrumbs
 */
export class ViewContainersComponent implements OnInit, OnChanges, OnDestroy {
  /**
   * A ComponentConfig class object containing various forms
   */
  @Input() componentConfig: ComponentConfig;
  /**
   * BreadCrumbData used in header for navigation
   */
  @Input() breadCrumbs: BreadCrumbData[];

  selectedValue: SelectedValue;
  /**
   * State Observable obtained from the componentStore and passed on to the different views
   */
  state$: Observable<any>; // = this.componentStore.vm$;
  isStandAlone: boolean;
  hasSelectedValue = false;
  /**
   * Action is used to select the view-container type - i.e List,Edit,Add,Relate etc
   */
  action: String | ActionState;
  addForms: OfbizForm[] = [];
  findForms: OfbizForm[] = [];
  listForms: OfbizList[] = [];
  relations: any[] = [];
  activeLevel: number;
  relation: Relation;
  masterDetails: any[] = [];
  // appContext:string;
  // activeLevelSubscription:Subscription;
  private destroy$ = new Subject<void>();
  refresh: string;

  incomingLink: OutGoingLink;

  /**
   * The currently selected relation
   */
  selectedRelation: Relation;
  /**
   * The currently selected masterDetail
   */
  selectedMasterDetail: Relation;
  /**
   * The currently selected Task
   */
  selectedTask: ComponentTask;

  initialComponentState: ComponentState = {
    workSpaceState: "",
  }
  /**
   * Check whether the action must be set from a menu click with an event value;
   * Initialially set to false.
   * When menuItem is clicked, the event property is evaluated;
   * If it contains a value then this is set to true;
   */
  menuAction: boolean;

  showAssistantButton: boolean = false;

  // Right sidebar state - used to control icon display, waving hand when closed and collapse panel when open
  isSideBarOpen: boolean = false;

  readonly selectedMasterDetail$ = this.componentStore.selectedMasterDetail$.pipe(
    takeUntil(this.destroy$),
    map(data => {
      console.log("Track MasterDetail", data);
      return data;
    })
  );

  @ViewChild("mainCard", { read: ElementRef }) mainCard: ElementRef;

  constructor(
    private componentStore: UbsComponentStoreService,
    private viewContainersService: ViewContainersService,
    private windowService: NbWindowService,
    private sidebarService: NbSidebarService,
    private renderer: Renderer2,
    private router: Router,
    private updateComponentStoreService: UpdateComponentStoreService,
    private iconLibraries: NbIconLibraries) {
    // Register icons
    this.iconLibraries.registerSvgPack('custom-icons', CUSTOM_ICONS);
    /* this.menuService.onItemClick()
    .pipe(takeUntil(this.destroy$))
    .subscribe((menuBag) => {
      console.log(menuBag.tag)
      if(menuBag.item.data["event"]){
        this.menuAction = true;
        console.log("MenuAction",this.menuAction);
      }
      this.handleMenuItemSelect(menuBag);

    }); */
    this.updateComponentStoreService.getOutGoingLink()
      .pipe(take(1))
      .subscribe((incomingLink: OutGoingLink) => {
        this.incomingLink = incomingLink;
        console.log({ OutgoingLinkSubscription: incomingLink })
        this.initialComponentState.outGoingLink = incomingLink;
        /* this.componentStore.selectedValue$.pipe(take(1)).subscribe(data => {
          console.log({"Checking selectedValue on incoming link":data});
          this.updateComponentStoreService.getSelectedValue()
          .pipe(take(1))
          .subscribe(data => {
            if(data != null && data != undefined){
              this.selectedValue = data;
            }
          })
        }) */
      })


    /* this.router.events.pipe()
    .subscribe((event:Event) => {
      if (event instanceof NavigationEnd) {
        combineLatest([
          this.componentStore.outGoingLink$.pipe(take(1)),
          this.route.paramMap.pipe(take(1))
          ])
        .pipe()
        .subscribe(([outGoingLink,params]:[OutGoingLink,ParamMap]) => {

          if(outGoingLink != null)  {
            console.log({OutgoingLink:outGoingLink});
            this.initialComponentState.outGoingLink = outGoingLink;

          }
        })
      }
    }); */

  }



  ngOnInit(): void {
    // this.componentStore.updateComponentConfig(null);
    this.componentStore.vm$
      .pipe(takeUntil(this.destroy$), delay(0))
      .subscribe(state => {
        this.activeLevel = state.activeLevel;
        this.selectedValue = state.selectedValue;
        this.action = state.action;
        console.log("Action In VM$ subscription: ", this.action)
        console.log("SelectedValue In VM$ subscription: ", state.selectedValue)
      })
    /* this.componentStore.action$
    .subscribe(data => {
      this.action = data;
      console.log("Action In ACTION$ subscription: ",this.action)
    }); */
    /* this.componentStore.selectedValue$
      .pipe(takeUntil(this.destroy$))
      .subscribe((selectedValue:SelectedValue) => {
        if(selectedValue){
          this.hasSelectedValue = true;
          this.selectedValue = selectedValue;
        }
      }); */


  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["componentConfig"]) {
      console.log("Component Config Updated", this.componentConfig);
      if (this.componentConfig.menuAndTitleOptions != undefined) {
        /**
         * Set the menu and title options for the component
         */
        const menuAndTitleOptions: MenuAndTitleOptions = this.componentConfig.menuAndTitleOptions;
        /**
         * Set the menu and title options for the component in the viewContainersService
         */
        this.viewContainersService.setMenuAndTitleOptions(menuAndTitleOptions.menuTag, menuAndTitleOptions);

        /**
         * Subscribe to the activeMenuTag$ observable to get the active menu tag
         */
        this.viewContainersService.activeMenuTag$.subscribe(menutag => {
          console.log(menutag);
          this.viewContainersService.menuAndTitleOptions$.subscribe(data => {
            console.log(data);
          })
        })
        // this.viewContainersService.menuAndTitleOptions$.next(menuAndTitleOptions);
        // this.viewContainersService.addMenuAndTitleOptions(this.componentConfig.menuAndTitleOptions)
      }
      /**
     * Set the topList for the component
     */
      if (this.listForms && this.listForms.length > 0) {
        const topList = this.listForms[0];
        console.log(topList);
      }
      /**
       * Check if the component is a stand alone component.  Standalone is not part of the Angular StandAlone architecture
       * Standalone is is used here to determine whether a component is part of a composite view or not
       */
      this.isStandAlone = this.componentConfig.standAlone ? this.componentConfig.standAlone : false;
      /**
       * Not sure about this - have to check ity out
       */
      this.componentStore.outGoingLink$.pipe().subscribe(data => { this.incomingLink = data });
      console.log({ IncomingLink: this.incomingLink });

      const entries = Object.entries(this.componentConfig)
      this.addForms = this.viewContainersService.getForms(entries, this.addForms, "addForm");
      console.log(this.componentConfig.title, this.addForms, this.action);
      if (this.action == undefined) {
        this.componentStore.vm$.pipe(take(1)).subscribe(data => {
          if (data != null && data != undefined) {
            console.log("Data in ngOnChanges: ", data);
            if (data.action != null && data.action != undefined) {
              this.action = data.action;
              if (this.action == 'master-detail') {
                if (this.selectedRelation != null && this.selectedRelation != undefined) {
                  this.listForms = [this.selectedRelation.listForm];
                } else {
                  console.log("No selected Relations: ", this.relations);
                  // there is no selected Relation
                  if (this.relations.length > 0) {
                    this.selectedRelation = this.relations[0];
                    this.listForms = [this.selectedRelation.listForm];
                  } else {
                    this.listForms = this.viewContainersService.getForms(entries, this.listForms, "listForm");
                  }
                }
              } else {
                this.listForms = this.viewContainersService.getForms(entries, this.listForms, "listForm");
              }
              console.log(this.listForms)
            } else {
              this.action = this.resolveAction();
            }
          } else {
            console.log("Action is still undefined cause there's no state data")
          }
        });
      }/* else{
        this.listForms = this.viewContainersService.getForms(entries,this.listForms,"listForm");
      } */
      console.log({ "Action in ngOnChanges: ": this.action });

      console.log({ ListForms: this.listForms, Action: this.action });
      // this.listForms = this.viewContainersService.getForms(entries,this.listForms,"listForm");
      this.findForms = this.viewContainersService.getForms(entries, this.findForms, "findForm");
      this.relations = this.viewContainersService.getRelations(entries, this.relations);
      this.masterDetails = this.viewContainersService.getMasterDetails(entries, this.masterDetails);
      console.log({ RelationsSet: this.relations });
      console.log({ MasterDetailsSet: this.masterDetails });
      /* if(this.relations != null && this.relations != undefined){
        this.componentConfig.relations = this.relations;
      } */
      this.componentConfig.addForms = this.addForms;
      this.componentConfig.listForms = this.listForms;

      this.initialComponentState.workSpaceState = this.componentConfig.title;
      this.initialComponentState.callState = LoadingState.INIT;
      this.initialComponentState.firstVisit = true;
      this.initialComponentState.action = this.componentConfig.defaultAction ? this.componentConfig.defaultAction : this.resolveAction();
      this.initialComponentState.componentConfig = this.componentConfig;
      this.initialComponentState.breadCrumbs = this.resolveBreadCrumbs();
      this.initialComponentState.activeLevel = this.resolveLevel(),
        this.initialComponentState.selectedRelation = this.componentConfig.defaultAction ? this.resolveselectedRelation(this.componentConfig.defaultAction) : null;
      this.initialComponentState.selectedMasterDetail = this.componentConfig.selectedMasterDetails ? this.componentConfig.selectedMasterDetails : null;
      this.initialComponentState.selectedTask = this.componentConfig.selectedTask ? this.componentConfig.selectedTask : null;
      // this.initialComponentState.selectedMasterDetail = this.componentConfig.defaultAction?this.resolveselectedMasterDetail(this.componentConfig.defaultAction):null;
      console.log(this.selectedValue)
      if (this.selectedValue != undefined) {
        this.initialComponentState.selectedValue = this.selectedValue;
      } else {
        this.initialComponentState.selectedValue = this.resolveSelectedValue(this.componentConfig.defaultAction);
      }

      console.log(this.initialComponentState)

      this.componentStore.setState(this.initialComponentState);

      console.log({ TrackChanges: this.relations, activeLevel: this.activeLevel, listForms: this.listForms })
      this.setSettings(this.componentConfig.settings);

      this.state$ = this.componentStore.vm$;
      this.state$.subscribe(console.log);
      this.componentStore.vm$.subscribe(console.log)

      if (this.incomingLink) {
        console.log({ IncomingLink: this.incomingLink });
      }
      this.componentStore.componentConfig$.subscribe(console.log);
      this.componentStore.outGoingLink$.subscribe(console.log)
      // Check for assistants
      if (this.componentConfig.assistant != null && this.componentConfig.assistant != undefined) {
        console.log({ Assistant: this.componentConfig.assistant });
        this.setAssistantButton(this.componentConfig.assistant);
        // this.viewContainersService.setAssistant(this.componentConfig.assistant);
      }
    }

  }


  setSettings(settings: any[]) {
    this.viewContainersService.setSettings(settings);
  }

  handleMenuItemSelect(menuBag: NbMenuBag): void {
    console.log("Handle Menu Item: " + menuBag.item);
    const menutag = menuBag.tag;
    console.log(menutag);
    switch (menutag) {
      case "menu":
        this.viewContainersService.setListSelectedValue(null);
        this.componentConfig.searchResults = null;
        this.componentStore.updateAction(ActionState.LIST);
        this.componentStore.updateComponentConfig(this.componentConfig);
        this.viewContainersService.setSettings(null);
        break;
      case "type-menu":
        const selectedComponent = this.componentConfig.settings.find(setting => setting.entityName == menuBag.item.queryParams["entityName"]);
        if (selectedComponent) {
          this.windowService.open(WindowContainerComponent,
            {
              title: selectedComponent.title,
              context: { "componentConfig": selectedComponent, "state": this.state$ },
              windowClass: 'window-limited-height'
            }
          );
        }
        break;
      case "contextMenu":
        console.log("Action From Menu Item", menuBag.item.data.event);
        const event = menuBag.item.data.event ? menuBag.item.data.event : null;
        let actionState;
        if (event != null) {
          actionState = event as ActionState;
          switch (actionState) {
            case ActionState.RELATE:
              console.log({ RelationLength: this.relations.length });
              if (this.relations.length > 0) {
                this.relations.forEach((relationSet: Relation[]) => {
                  relationSet.forEach(relation => {
                    if (relation.title == menuBag.item.title) {
                      this.selectedRelation = relation;
                      this.componentStore.updateSelectedRelation(this.selectedRelation);
                    }
                  })

                })
              }
              break;
            case ActionState.MASTERDETAIL:
              console.log({ MasterDetailsLength: this.masterDetails.length });
              if (this.masterDetails.length > 0) {
                this.masterDetails.forEach((masterDetailSet: Relation[]) => {
                  masterDetailSet.forEach(masterDetail => {
                    if (masterDetail.title == menuBag.item.title) {
                      this.selectedMasterDetail = masterDetail;
                      console.log({ SelectedMasterDetail: this.selectedMasterDetail });
                      this.componentStore.updateSelectedMasterDetail(this.selectedMasterDetail);
                    }
                  })

                })
              }
              break;

            default:
              break;
          }
        } else {
          actionState = ActionState.LIST;
        }

        // let actionState = ActionState.RELATE;


        // this.selectedRelation = this.relations.find((relation:Relation) => relation.title == menuBag.item.title);
        // console.log({ContextMenuClicked:{relations:this.relations,selectedRelation:this.selectedRelation,menuBag:menuBag}})

        this.componentStore.updateAction(actionState);
        break
      default:
        console.log(menuBag)
        this.handleMenuItemSelected(menuBag.item.data)
        break;
    }

  }

  handleMenuItemSelected(selectedValue: SelectedValue): void {
    console.log({ TrackSelectedValue: "ListContainerComponent", value: selectedValue });
    console.log({ "TrackHyperLink": "handleHyperLinkSelected", "ListContainerComponentValue:": selectedValue });
    console.log("SelectedValue in handleHyperLinkSelected", selectedValue);
    const event = selectedValue.event;
    console.log(event)
    switch (event) {
      case ActionState.VIEW:
        this.componentStore.updateAction(ActionState.VIEW);
        break;
      case ActionState.LIST:
        this.componentStore.updateAction(ActionState.LIST);
        /* let hyperlinkListForm = this.listForms.find(listForm => listForm.listFormName == selectedValue.data.formData.formName);
        if(hyperlinkListForm != undefined){
          this.listForm = hyperlinkListForm;
          if(this.listForm.cardMode != undefined){
            this.cardMode = this.listForm.cardMode;
          }
        }
        console.log({HyperlinkListForm:hyperlinkListForm,cardMode:this.cardMode});
        this.setActiveLevel(selectedValue.data.formData.formName,this.listForms);
        this.remoteFormData = {
          formData:selectedValue.data["formData"],
          appContext:selectedValue.data["appContext"],
          parameters:selectedValue.data["parameters"]
        }
        console.log({RemoteFormDataHandleHyperLink:this.remoteFormData});
        this.componentStore.componentConfig$
        .subscribe((componentConfig:ComponentConfig) => {
          if(componentConfig !=null){
            this.setFieldsFromListForm(this.componentConfig,selectedValue.type);
            this.componentStore.updateAction(ActionState.LIST);
          }
        }); */
        break;
      case ActionState.DELETE:
        console.log({ deleteState: event });
        /*         this.remoteFormData.formData = selectedValue.data["formData"];
                this.remoteFormData["parameters"] = selectedValue.data["parameters"]; */
        break;
      case ActionState.EDIT:
        console.log({ "TrackEdit": event, "component": "UpdateComponentStoreService" });
        this.componentStore.updateAction(ActionState.EDIT);
        break;
      case ActionState.ADD:
        /* this.componentStore.selectedValue$.subscribe((data) => {console.log("SelectedValue in Add",data);})
        this.remoteFormData.formData = selectedValue.data["formData"];
        this.remoteFormData["parameters"] = selectedValue.data["parameters"];
        console.log({remoteFormData:this.remoteFormData}); */
        this.componentStore.updateAction(ActionState.ADD);
        break;
      case ActionState.LINK:
        console.log({ "linkingThings": event, "component": "ListContainerComponent" });
        this.componentStore.outGoingLink$.subscribe(data => {
          console.log({ OutGoingLink: data });
        })
        break;
      case ActionState.RELATE:
        console.log({ RelationLength: this.relations.length });
        try {
          const title = selectedValue.type;
          this.relations.forEach((relationSet: Relation[]) => {
            relationSet.forEach(relation => {
              if (relation.title == title) {
                this.selectedRelation = relation;
                // console.log({ContextMenuClicked:{relations:this.relations,selectedRelation:this.selectedRelation,menuBag:menuBag}})
              }
            })
          })
        } catch (e) {
          console.log(e);
        }
        this.componentStore.updateSelectedRelation(this.selectedRelation);
        this.componentStore.updateAction(ActionState.RELATE);
        break;
      default:
        break;
    }
    this.selectedValue = selectedValue;
    this.componentStore.updateSelectedValue(selectedValue);

  }





  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setList(e) {
    // console.log("At the top",e);
    this.componentStore.updateAction(ActionState.LIST);
  }

  resolveAction(): ActionState {
    let action = ActionState.LIST;
    if (this.incomingLink != null && this.incomingLink != undefined) {
      const target = this.incomingLink.target;
      if (this.listForms && this.listForms.length > 0) {
        const form = this.addForms.find(addForm => addForm.formName == target);
        if (form != undefined) {
          action = ActionState.EDIT;
          if (this.incomingLink.remoteFormData != null && this.incomingLink.remoteFormData != undefined) {
            this.selectedValue = {
              data: {
                formData: this.incomingLink.remoteFormData.formData,
                parameters: this.incomingLink.parameters,
              },
              type: this.incomingLink.target,
            }
            console.log({ TrackSelectedValue: this.selectedValue, breadCrumbs: this.breadCrumbs })
          }
        }
      }
    }
    this.action = action;
    return action
  }

  resolveLevel(): number {
    let level = 1;
    this.updateComponentStoreService.getOutGoingLink()
      .pipe(take(1))
      .subscribe(outGoingLink => {
        console.log({ OutgoingLinkSubscription: outGoingLink });
      })
    if (this.incomingLink != null && this.incomingLink != undefined) {
      console.log({ OutgoingLinkSubscription: "There's an incomingLink" });
      const target = this.incomingLink.target;
      let formType = "edit";
      if (this.listForms && this.listForms.length > 0) {
        const form = this.addForms.find(addForm => addForm.formName == target);
        if (form != undefined) {
          formType = "list"
        }
      }
      switch (formType) {
        case "list":
          level = this.listForms.findIndex(listForm => listForm.listFormName == target);
          break;
        case "edit":
          level = this.addForms.findIndex(addForm => addForm.formName == target);
          break;
        default:
          level = 1;
          break;
      }
    }
    if (level == -1) {
      level = 1;
    }
    this.activeLevel = level;
    console.log({ activeLevel: this.activeLevel });
    return level;
  }

  resolveBreadCrumbs(): BreadCrumbData[] {
    if (this.incomingLink != null && this.incomingLink != undefined) {
      if (this.breadCrumbs != null && this.breadCrumbs != undefined) {
        this.breadCrumbs.forEach(breadCrumb => {
          if (breadCrumb.selectedValue.data.parameters != undefined) {
            if (this.incomingLink.parameters != undefined && this.incomingLink.parameters != null) {
              Object.keys(breadCrumb.selectedValue.data.parameters).forEach(key => {
                if (this.incomingLink.parameters.hasOwnProperty(key)) {
                  breadCrumb.selectedValue.data.parameters[key] = this.incomingLink.parameters[key]
                  breadCrumb.label = this.incomingLink.parameters[key];
                }
              })
            }
          }

        })
      }
    }
    // console.log({TRackBreadCrumbData:this.breadCrumbs})
    return this.breadCrumbs
  }

  resolveselectedRelation(action: ActionState): Relation {
    let relation: Relation = null;
    if (this.componentConfig.selectedRelation != undefined) {
      relation = this.componentConfig.selectedRelation;
    } else if (action == ActionState.RELATE) {

      relation = this.componentConfig.relations[0];
      // this.componentStore.updateSelectedRelation(this.selectedRelation);
      /* if(this.selectedValue == undefined && this.componentConfig.relations.length > 0){
        this.selectedRelation = this.componentConfig.relations[0];
      } */
    }
    return relation
  }

  resolveselectedMasterDetail(action: ActionState): Relation {
    let masterDetail: Relation = null;
    this.selectedMasterDetail$.pipe(takeUntil(this.destroy$)).subscribe((_masterDetail: Relation) => {
      console.log("Track MasterDetail", _masterDetail);
      masterDetail = _masterDetail;
      if (masterDetail == null) {
        masterDetail = this.componentConfig.selectedMasterDetails ? this.componentConfig.selectedMasterDetails : undefined;
        console.log("Track MasterDetail", masterDetail, this.componentConfig);
      } else {
        console.log("Track MasterDetail", masterDetail);
      }
    })
    console.log(masterDetail);
    return masterDetail;
  }

  resolveSelectedValue(action: ActionState): SelectedValue {
    console.log(action)
    let selectedValue: SelectedValue = null;
    if (action == ActionState.EDIT) {
      const addForm = this.addForms[0];
      if (addForm.breadCrumbData != undefined) {
        selectedValue = addForm.breadCrumbData.selectedValue;
        console.log(selectedValue);
      }
    }
    return selectedValue;
  }

  getCumulativePathSegments = (path) => {
    const cumulativePath = (acc) => (value) => (acc += `${value}/`)
    return path.split('/').filter(Boolean).map(cumulativePath('/'))
  }

  setAssistantButton(assistant: AssistantConfig) {
    // first check if the current path is the same as the one on the assistantConfig
    const pathCheck = this.router.url.endsWith(assistant.path);
    const actionCheck = this.action;
    const triggers = assistant.contextualTriggers;
    if (triggers.onCreate && pathCheck) {
      this.showAssistantButton = true;
    } else {
      this.showAssistantButton = false;
    }
    console.log({ AssistantConfig: assistant, pathCheck: pathCheck, actionCheck: actionCheck });
    console.log(this.showAssistantButton)
  }

  toggleSidebar(e) {
    console.log("Sidebar toggle clicked", e);
    // this.viewContainersService.toggleSidebar()
    this.sidebarService.getSidebarState('right').subscribe(state => {
      console.log(state);
      if (state == "collapsed") {
        this.sidebarService.expand('right');
        this.isSideBarOpen = true;
        if (!this.mainCard.nativeElement.classList.contains('collapsed')) {
          this.renderer.addClass(this.mainCard.nativeElement, 'collapsed');
        }
      } else if (state == "expanded") {
        this.sidebarService.collapse('right');
        this.isSideBarOpen = false;
        if (this.mainCard.nativeElement.classList.contains('collapsed')) {
          this.renderer.removeClass(this.mainCard.nativeElement, 'collapsed');
        }
      }
    })
    /* this.sidebarState$.pipe(takeUntil(this.destroy$)).subscribe(state => {
      console.log({SidebarState:state});
      if(state == "collapsed"){
        this.sidebarService.expand('right');
      }else if(state == "expanded"){
        this.sidebarService.collapse('right');
      }
    }) */
  }
}
